import script from "./objectHeaderText.vue?vue&type=script&setup=true&lang=js"
export * from "./objectHeaderText.vue?vue&type=script&setup=true&lang=js"

import "./objectHeaderText.vue?vue&type=style&index=0&id=13b64178&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b64178"]])

export default __exports__